import { HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { TimelineBumper } from 'app/agriculture/AgTimeline/components/TimelineBumper/TimelineBumper';
import './TimelineContent.scss';

interface TimelineContentProps {
    children?: ReactNode;
}

export function TimelineContent({ children }: TimelineContentProps) {
    return (
        <div className="TimelineContent">
            <TimelineBumper direction="left" />
            <div className="TimelineContent__inner">{children}</div>
            <TimelineBumper direction="right" />
        </div>
    );
}

function TimelineContentHeader({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) {
    return <div className={classNames('TimelineContent__header', className)}>{children}</div>;
}
TimelineContent.Header = TimelineContentHeader;

function TimelineContentRow({
    heading,
    children,
    className,
    ...divProps
}: {
    heading?: string;
    children: ReactNode;
    className?: string;
} & HTMLAttributes<HTMLDivElement>) {
    return (
        <div {...divProps} className={classNames('TimelineContent__row', className)}>
            {heading == null ? null : <h5 className="TimelineContent__row-heading">{heading}</h5>}
            <div className="TimelineContent__row-content">{children}</div>
        </div>
    );
}
TimelineContent.Row = TimelineContentRow;

function TimelineContentMain({
    children,
    className,
}: {
    children?: ReactNode;
    className?: string;
}) {
    return <div className={classNames('TimelineContent__main', className)}>{children}</div>;
}
TimelineContent.Main = TimelineContentMain;
